'use client'
import NextLink from '@/components/NextLink';
import { useItineraryStoreV2 } from '@/core/stores/itinerary/itineraryV2';
import { usePathname } from 'next/navigation';

export default function ItineraryMobileNavbar({ className = '' }: { className?: string }) {
    const pathname = usePathname();

    const { baseUrl } = useItineraryStoreV2()

    return (
        <div className={`${className} flex md:hidden   items-center gap-5`}>
            <NextLink
                href={baseUrl}
                className={`py-2 text-sm ${pathname === baseUrl ? "border-b border-b-secondary-500 text-secondary-500" : "border-b-none "}
                                                 `}
            >
                Overview
            </NextLink>
            <NextLink
                href={`${baseUrl}/explore`}
                className={`py-2 text-sm ${pathname === `${baseUrl}/explore` ? "border-b border-b-secondary-500 text-secondary-500" : "border-b-none "}
                                                 `}
            >
                {/* <Button isActive={!day} size='small' color={'ghost'}> */}
                Explore
                {/* </Button> */}
            </NextLink>
            <NextLink
                href={`${baseUrl}/hotels`}
                className={`py-2 text-sm ${pathname === `${baseUrl}/hotels` ? "border-b border-b-secondary-500 text-secondary-500" : "border-b-none "}
                                                 `}
            >
                {/* <Button isActive={!day} size='small' color={'ghost'}> */}
                Hotels
                {/* </Button> */}
            </NextLink>
        </div>
    );
}